<template>
  <div class="a4-page">
    <div class="w-fit">
      <div style="text-align: center; letter-spacing: 27px;">退職願</div>
      <div class="pr-20">一身上の都合により来る
        <span id="year" v-if="year">{{ year }}<span class="pt-0.5">年</span></span>
        <span class="pt-2">{{ month }}<span class="pt-0.5">月</span></span>
        <span class="pt-2">{{ day }}<span class="pt-0.5">日</span></span>
        をもって
      </div>
      <div class="pr-10">退職したく、お願い申し上げます。</div>
      <div class="pr-16">
        <span class="pt-60">年</span>
        <span class="pt-10">月</span>
        <span class="pt-10">日</span>
      </div>
      <div class="pt-64 pr-10">氏名<span class="pt-72 text-sm">印</span></div>
      <div class="pr-16">アポロ管財株式会社</div>
      <div class="pt-10">代表取締役社長<span class="pt-10">橋本 真紀夫</span><span class="pt-6">様</span></div>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'

  export default {
    components: {
    },

    data() {
      return {
        name: null,
        year: null,
        month: null,
        day: null
      }
    },

    async created() {
      let d = this.$route.query.day + ' 00:00:00'
      let year = moment(d).format('YYYY')
      const num = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const num2 = ['〇','一','二','三','四','五','六','七','八','九']
      for (let i = 0; i < num.length; i++) {
        const n = num[i]
        const n2 = num2[i]
        year = year.replace(new RegExp(n,"g"), n2)
      }

      let month = moment(d).format('M')
      let day = moment(d).format('D')
      const number = [
        '31','30','29','28','27','26','25','24','23','22','21',
        '20','19','18','17','16','15','14','13','12','11','10',
        '9','8','7','6','5','4','3','2','1'
      ]
      const number2 = [
        '三十一', '三十', '二十九', '二十八', '二十七', '二十六', '二十五', '二十四', '二十三', '二十二',
        '二十一', '二十', '十九', '十八', '十七', '十六', '十五', '十四', '十三', '十二',
        '十一', '十', '九', '八', '七', '六', '五', '四', '三', '二', '一'
      ]
      for (let i = 0; i < number.length; i++) {
        const n = number[i]
        const n2 = number2[i]
        month = month.replace(n, n2)
        day = day.replace(n, n2)
      }
      this.year = year
      this.month = month
      this.day = day
    },
  }
</script>

<style scoped>

  .a4-page {
    width: 210mm;
    height: 297mm;
    margin: 0 auto;           /* 中央寄せ */
    padding: 20mm 10mm;            /* 余白（必要に応じて調整） */
    background: white;        /* 背景を白に */
    box-shadow: 0 0 10px rgba(0,0,0,0.1); /* 画面で用紙っぽく見せる影 */
    box-sizing: border-box;   /* padding含めてサイズ調整 */
    writing-mode: vertical-rl;     /* 縦書き */
    text-orientation: upright;      /* 文字を立てる */
    font-family: "MS Mincho", "Hiragino Mincho Pro", "Yu Mincho", "TakaoMincho", "IPAMincho", serif;
    font-size: 18pt;
    line-height: 2;
    text-align: start;
    display: flex;
    justify-content: center; /* 横中央 */
    align-items: center;     /* 縦中央 */
  }

  /* 印刷時だけ適用 */
  @media print {
    body {
      width: 210mm;     /* A4幅 */
      height: 297mm;    /* A4高さ */
    }

    .a4-page {
      box-shadow: none; /* 印刷時は影を消す */
    }
  }

</style>